export const FIND_FILES_FAILURE = 'FIND_FILES_FAILURE';

export const findFilesFailure = ({ error, request }) => ({
    type: FIND_FILES_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});